import React from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'
import FilterMultiselect from '../filterMultiselect'

const rankMap = {
  'rank-0': 'No sales',
  'rank-1': 'Low',
  'rank-2': 'Medium',
  'rank-3': 'High',
  'rank-4': 'Top Sellers'
}

const FiltersSales = ({ locationParams, makeSearchLink, history, items }) => {
  const getFormattedOptions = options => {
    return options.map(option => {
      return {
        label: rankMap[option.key],
        ...option
      }
    })
  }

  return (
    <FilterMultiselect
      type="sales"
      items={getFormattedOptions(items)}
      locationParams={locationParams}
      makeSearchLink={makeSearchLink}
      history={history}
    />
  )
}

FiltersSales.propTypes = {
  locationParams: PropTypes.object.isRequired,
  makeSearchLink: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  items: PropTypes.array
}

export const FiltersSalesComponent = FiltersSales
export default withRouter(FiltersSales)
